module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_17_M_1.130fcd11.mp3";